import { render, staticRenderFns } from "./BlackjackValue.vue?vue&type=template&id=995f3fa2&scoped=true"
import script from "./BlackjackValue.vue?vue&type=script&lang=js"
export * from "./BlackjackValue.vue?vue&type=script&lang=js"
import style0 from "./BlackjackValue.vue?vue&type=style&index=0&id=995f3fa2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "995f3fa2",
  null
  
)

export default component.exports